module.exports = __webpack_public_path__ + "static/img/house.47a06193.webp";